

















import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import Loading from '@/components/Loading.vue'
import {Action, Getter} from 'vuex-class'
import {ScorecardEntity} from '@/entities/scorecard'
import ScorecardSubpage from '@/pages/scorecard/components/ScorecardSubpage.vue'
import {embedded} from '@/utils/react-native-webview'
import ScorecardGraph from '@/components/Scorecard/ScorecardGraph.vue'
import IconChangeUp from '@/assets/img/Icons/leaderboard-up.svg'
import IconChangeDown from '@/assets/img/Icons/leaderboard-down.svg'

@Component<ScorecardTrend>({
    components: {ScorecardGraph, ScorecardSubpage, Loading}
})
export default class ScorecardTrend extends Vue {

    @Getter public slide !: string
    @Getter public scorecard!: ScorecardEntity
    @Getter public scorecardLoading!: boolean

    @Prop({type: String, default: null})
    public teamMemberUserId !: string // view another users trend

    public get loading() {
        return this.scorecardLoading
    }

    public get ratingLabel() {
        return this.scorecard.isFiveScoreQuestionType ? 'Rating' : 'NPS'
    }

    public get nps() {
        if (!this.scorecard) {
            return 'loading...'
        }
        return this.scorecard.nps
    }

    public get title() {
        if (!this.scorecard) {
            return 'loading...'
        }
        const iconSrc = this.scorecard.change >= 0 ?IconChangeUp:IconChangeDown

        return `${this.ratingLabel} ${this.nps}
                <img class="trend-caret" src="${iconSrc}">
                        <small style="font-size: 12px;">${Number(this.scorecard.change).toFixed(1)}</small>`
    }

    public get embedded() {
        return embedded
    }

}
